import { FC } from 'react';
import { Props } from './types';
import { Content } from './style';
import { Label, Title } from '../style';

const Group: FC<Props & { children?: any }> = ({
  label,
  labelIcon,
  labelPalette,
  gap,
  children,
}) => (
  <Label>
    <Title labelPalette={labelPalette}>
      {labelIcon}
      {label}
    </Title>
    <Content gap={gap}>{children}</Content>
  </Label>
);

export default Group;
